import { z } from "zod";

/**
 * CargoSchema
 */

export const CargoSchema = z.object({
  ativo: z.coerce.number(),
  descricao: z.string().nonempty({ message: "É necessário preencher este campo!" }),
  atribuicoes: z.string().nonempty({ message: "É necessário preencher este campo!" }),
  escolaridade: z.string().default(''),
  experiencia: z.string().default(''),
  qualificacoes: z.string().default(''),
  treinamentos: z.array(z.object({
    idTreinamento: z.coerce.number(),
  })).nullable().default(null),
  habilidades: z.array(z.object({
    idHabilidade: z.coerce.number(),
  })).nullable().default(null),
});

/**
 * CargoForm
 */

export type CargoForm = z.infer<typeof CargoSchema>;

/**
 * defaultCargoForm
 */

export const defaultCargoForm: Partial<CargoForm> = {
  ativo: 1,

}